var exports = {
  "Box": "Box__zIQEG4",
  "Box_1": "Box_1__u_kjhl",
  "IconButton": "IconButton__GFgOKC",
  "Box_1__hasWritePermissions": "Box_1__hasWritePermissions__Y1_2xl",
  "Octicon": "Octicon__B1U4HX",
  "SanitizedHtml": "SanitizedHtml__Z-fMho",
  "Box_2": "Box_2__25RWsy",
  "Link": "Link__HVt9OP",
  "Label": "Label__Kbrbis",
};

__webpack_require__.r(module.exports = exports);
